/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:46:47
 * @LastEditTime: 2022-09-20 13:33:58
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderList/index.tsx
 */
import { NoDataPage } from '@/src/components';
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import {
  getOrders,
  orderInit,
  printCourierLabel,
  printInvoice,
} from '@/src/request/order';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import {
  ILogisticsMethod,
  OrderList as IOrderList,
  IOrderStatus,
} from '@/src/types/common/order';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Spin } from 'antd';
import moment from 'moment';
import React, { memo, useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { NEW, defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { randomNumber } from 'src/tools/helper';
import { breadcrumbData, columns, filterList, tabsConfig } from './config';
import css from './css.module.less';
//import { get } from 'lodash';
import { i18nGet } from 'src/tools/tools';
//import { nameDict, EnumFieldType } from 'src/types/common/customerDb';

const customerConvertQuery = (filter) => {
  const {
    salesChannelUuids = [],
    orderStatuses = [],
    paymentStatuses = [],
    fulfillmentStatuses = [],
  } = filter;

  const re: any = {};
  if (salesChannelUuids && salesChannelUuids.length > 0) {
    re.salesChannelUuids = salesChannelUuids.map((i) => {
      const { value } = i;
      return value;
    });
  }
  if (orderStatuses && orderStatuses.length > 0) {
    re.orderStatuses = orderStatuses.map((i) => {
      const { value } = i;
      return value;
    });
  }
  if (paymentStatuses && paymentStatuses.length > 0) {
    re.paymentStatuses = paymentStatuses.map((i) => {
      const { value } = i;
      return value;
    });
  }
  if (fulfillmentStatuses && fulfillmentStatuses.length > 0) {
    re.fulfillmentStatuses = fulfillmentStatuses.map((i) => {
      const { value } = i;
      return value;
    });
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};
const permissions = () => {
  const view_all_orders_listing_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.AllOrders,
        operation: EnumOperation.view_all_orders_listing_page,
      }),
    ],
  });
  const view_order_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.AllOrders,
        operation: EnumOperation.view_order_details_page,
      }),
    ],
  });

  const create_edit_order = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCreation,
        operation: EnumOperation.create_edit_order,
      }),
    ],
  });

  return {
    view_all_orders_listing_page,
    view_order_details_page,
    create_edit_order,
  };
};

const OrderList = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const {
    view_all_orders_listing_page,
    view_order_details_page,
    create_edit_order,
  } = permissions();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [orders, setOrders] = useState<IOrderList[]>([]);
  /* 分页 */
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [salesChannelList, setSalesChannelList] = useState([]);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [reportingCurrency, setReportingCurrency] = useState('');
  const [timezoneInGMT, setTimezoneInGMT] = useState('');
  const [countOfReadyToPack, setCountOfReadyToPack] = useState(0);
  const [countOfReadyToPick, setCountOfReadyToPick] = useState(0);
  const [countOfReadyToShip, setCountOfReadyToShip] = useState(0);
  const [noProducts, setNoProducts] = useState(true);
  const [sortBy, setSortBy] = useState<any>({});
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [tabsActive, setTabsActive] = useState('');
  //分页配置
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const { clearSearchState, queryProps, search } = useQueries(
    filterList(salesChannelList, { i18n }),
    [],
    customerConvertQuery,
  );

  /* 多选 */
  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(orders);

  const buttonMenu = [
    //Bulk Edit
    {
      key: 1,
      value: i18nGet(i18n, `allOrders.orderlist.btnmenu_invoices`),
      function: () => {
        setLoadingPage(true);
        if (selectedRowKeys.length > 0) {
          printInvoice({ orderUuids: selectedRowKeys, pageSize: 'A4' }).then(
            (data) => {
              setLoadingPage(false);
            },
          );
        }
      },
    },
    {
      key: 2,
      value: i18nGet(i18n, `allOrders.orderlist.btnmenu_CourierLabels`),
      function: () => {
        if (selectedRowKeys.length > 0) {
          printCourierLabel({
            orderUuids: selectedRowKeys,
            pageSize: 'A4',
          });
        }
      },
    },
  ];

  //清除table状态
  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
    setSelectedAll(false);
  };

  //tab改变事件
  const tabChange = (activeKey) => {
    clearTableState();
    clearSearchState();
    setCurrent(0);
    setStartDate('');
    setEndDate('');
    setTabsActive(activeKey);
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    const data = search;
    data.logisticsMethod = [];
    const status = tabsActive
      ? tabsActive == IOrderStatus.SUSPENDED ||
        tabsActive == IOrderStatus.CANCELLED
        ? { orderStatuses: [tabsActive] }
        : { fulfillmentStatuses: [tabsActive] }
      : {};
    const clickCollectIndex = (data.fulfillmentStatuses || []).findIndex(
      (item) => item === ILogisticsMethod.ClickCollect,
    );
    if (clickCollectIndex > -1) {
      data.logisticsMethod.push(ILogisticsMethod.ClickCollect);
      data.fulfillmentStatuses.splice(clickCollectIndex, 1);
    }
    const deliveryIndex = (data.fulfillmentStatuses || []).findIndex(
      (item) => item === ILogisticsMethod.Delivery,
    );
    if (deliveryIndex > -1) {
      data.logisticsMethod = data.logisticsMethod.concat([
        ILogisticsMethod.Delivery,
        ILogisticsMethod.ParcelLocker,
      ]);
      data.fulfillmentStatuses.splice(deliveryIndex, 1);
    }
    const _data = {
      ...data,
      ...status,
      startDate,
      endDate,
      ...(Object.keys(sortBy).length ? { sortBy } : {}),
    };
    getOrders(current * pageSize, pageSize, _data).then((res) => {
      const { totalCount } = res;
      setTotal(totalCount);
      const orders: IOrderList[] = res.results.map((i) => {
        return {
          ...i,
          key: randomNumber(),
        };
      });
      setOrders(orders);
      setLoading(false);
    });
  };

  React.useEffect(() => {
    if (view_all_orders_listing_page) {
      if (!loading) {
        setLoading(true);
      }
      const data = {};
      orderInit(current * pageSize, pageSize, data).then((res) => {
        const {
          countOfReadyToPack = 0,
          countOfReadyToPick = 0,
          countOfReadyToShip = 0,
          reportingCurrency = '',
          timezoneInGMT = '',
          salesChannels = [],
          orders: { totalCount = 0, results = [] } = {},
        } = res;
        setSalesChannelList(salesChannels);
        setReportingCurrency(reportingCurrency);
        setTimezoneInGMT(timezoneInGMT);
        setCountOfReadyToPack(countOfReadyToPack);
        setCountOfReadyToPick(countOfReadyToPick);
        setCountOfReadyToShip(countOfReadyToShip);
        setTotal(totalCount);
        setOrders(results);
        setLoading(false);
        if (totalCount > 0) {
          setNoProducts(true);
        } else {
          setNoProducts(false);
        }
      });
    }
  }, []);

  useAfterDidMountEffect(() => {
    if (view_all_orders_listing_page) {
      getProduct(() => void 0);
    }
  }, [tabsActive, current]);

  useAfterDidMountEffect(() => {
    if (view_all_orders_listing_page) {
      if (!current) {
        getProduct(() => void 0);
      } else {
        setCurrent(0);
      }
    }
  }, [pageSize, search, sortBy, startDate, endDate]);

  const handleLinkToAddOrder = () => {
    history.push(`/orderCreate/${NEW}`);
  };

  const pageLayoutProps = {
    title: i18nGet(i18n, 'allOrders.orderlist.pageLayoutProps_title'),
    addText: i18nGet(i18n, 'allOrders.orderlist.pageLayoutProps_addText'),
    addFun: create_edit_order ? handleLinkToAddOrder : null,
    tabChange,
    activeKey: tabsActive,
    tabsConfig: tabsConfig(
      i18n,
      countOfReadyToPack,
      countOfReadyToPick,
      countOfReadyToShip,
    ),
  };

  const handleTimePickerOnChange = (data) => {
    if (data) {
      setStartDate(data[0].format('YYYY-MM-DD'));
      setEndDate(data[1].format('YYYY-MM-DD'));
    } else {
      setStartDate('');
      setEndDate('');
    }
  };

  return (
    <Spin {...{ spinning: loadingPage }}>
      {/* {nameDict[EnumFieldType.FirstName]} */}
      <React.Fragment>
        <Breadcrumb
          className={css.breadcrumb}
          breadcrumbData={breadcrumbData({ getI18n })}></Breadcrumb>
        {!noProducts ? (
          <NoDataPage
            title={i18nGet(i18n, 'allOrders.orderlist.return_NoDataPage_title')}
            introduce={i18nGet(
              i18n,
              'allOrders.orderlist.return_NoDataPage_introduce',
            )}
            buttonTitle={i18nGet(
              i18n,
              'allOrders.orderlist.return_NoDataPage_buttonTitle',
            )}
            onClick={handleLinkToAddOrder}
            disabled={!create_edit_order}
          />
        ) : (
          //allOrders.orderlist.config_columns_orderCreated
          <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
            <GlobalTable
              id='ProductListTable'
              showTimePicker
              timePickerValue={[
                startDate ? moment(startDate) : '',
                endDate ? moment(endDate) : '',
              ]}
              timePickerOnChange={handleTimePickerOnChange}
              queryProps={queryProps}
              dataSource={orders}
              columns={columns(timezoneInGMT, reportingCurrency, { i18n })}
              selectedAll={selectedAll}
              setSelectedAll={setSelectedAll}
              buttonMenu={buttonMenu}
              rowKey='uuid'
              pagination={paginationProps}
              current={current}
              setCurrent={setCurrent}
              pageSize={pageSize}
              setPageSize={setPageSize}
              total={total}
              holdHeader
              bulkEditText={getI18n('general.print')}
              rowSelection={rowSelection}
              selectedRowKeys={selectedRowKeys}
              hidePagination={total == 0}
              onRow={(record) => ({
                onClick: () => {
                  if (
                    view_order_details_page &&
                    record.source == 'Portal' &&
                    !record.paymentMethod &&
                    (record.orderStatus == IOrderStatus.DRAFT ||
                      record.orderStatus == IOrderStatus.SAVED)
                  ) {
                    history.push(`/orderCreate/${record.uuid}`);
                  } else {
                    history.push(`/order/${record.uuid}`);
                  }
                },
              })}
              onChange={(_, s, sort) => {
                const ascent = sort.order == 'ascend' ? true : false;
                const field =
                  sort.field == 'reportingTotalPrice'
                    ? 'totalPrice'
                    : sort.field;
                setSortBy({ field, ascent });
              }}
              loading={loading}
            />
          </ListPageLayout>
        )}
      </React.Fragment>
    </Spin>
  );
};

export default memo(OrderList);
